import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import {
    isDingDing,
    isSSAI
} from '../core/utils';
var EndPanel = function () {
    function EndPanel(player) {
        var _this = this;
        _classCallCheck(this, EndPanel);
        if (isDingDing || isSSAI) {
            return;
        }
        this.player = player;
        this.player.on('ended', function () {
            _this.show();
        });
        this.player.template.endPanelReplay.addEventListener('click', function () {
            _this.hide();
            _this.player.seek(0);
            _this.player.play();
            _this.player.events.trigger('replay');
        });
        if (this.player.options.endpanel.feedbackBtn) {
            this.player.template.endPanelFeedback.addEventListener('click', function () {
                var source = 'EndPanel';
                _this.hide();
                _this.player.feedback.show(source);
            });
        }
    }
    _createClass(EndPanel, [
        {
            key: 'hide',
            value: function hide() {
                this.player.template.endPanel.classList.add('dplayer-endpanel-wrap-hide');
            }
        },
        {
            key: 'show',
            value: function show() {
                console.log(this.player.template.endPanel.classList);
                this.player.template.endPanel.classList.remove('dplayer-endpanel-wrap-hide');
            }
        }
    ]);
    return EndPanel;
}();
export default EndPanel;